<section class="availabilitiesForm" (window:resize)="onResize()">
	<!-- Loader. -->
	<section *ngIf="isLoading" style="text-align: center">
		<img
			src="/assets/images/preloaders/global_preloader.gif"
			style="margin-top: 20px"
		/>
	</section>

	<!-- Form. -->
	<section *ngIf="!isLoading">
		<!-- Calendars container. -->
		<div class="formContainer calendarsContainer apDetails">
			<!-- Date. -->
			<div class="aps-block" style="margin-top: 0">
				<table class="dtTable">
					<tr>
						<td colspan="2">{{ 'GENERAL.PERIOD' | translate | uppercase }}</td>
					</tr>
					<tr>
						<td class="tdCalendarLabel tdCalFrom">
							{{ 'GENERAL.FROM' | translate | uppercase }}
						</td>
						<td class="tdCalendarInput">
							<p-calendar
								[readonlyInput]="true"
								[(ngModel)]="newPeriodDate[0]"
								[selectionMode]="'single'"
								inputId="icon"
								showIcon="true"
								[touchUI]="true"
								dateFormat="dd/mm/yy"
								[placeholder]="newPeriodDate[0] | date: 'dd/mm/yy'"
								[monthNavigator]="true"
								yearRange="2000:2030"
								inputId="navigators"
								[yearNavigator]="true"
							>
							</p-calendar>
						</td>
					</tr>
					<tr>
						<td class="tdCalendarLabel tdCalTo">
							{{ 'GENERAL.TO' | translate | uppercase }}
						</td>
						<td class="tdCalendarInput">
							<p-calendar
								[readonlyInput]="true"
								[(ngModel)]="newPeriodDate[1]"
								[selectionMode]="'single'"
								[placeholder]="newPeriodDate[1] | date: 'dd/mm/yy'"
								showIcon="true"
								[touchUI]="true"
								dateFormat="dd/mm/yy"
								inputId="icon"
								[monthNavigator]="true"
								yearRange="2000:2030"
								inputId="navigators"
								[yearNavigator]="true"
							>
							</p-calendar>
						</td>
					</tr>
					<tr>
						<td colspan="2">
							{{ 'TOOLTIPS.AVAILABILITIES.MAXVALUE' | translate }}
						</td>
					</tr>
				</table>
			</div>

			<!-- Timezone. -->
			<div class="aps-block">
				<p class="aps-title">
					{{ 'GENERAL.TIMEZONE' | translate | uppercase }}
				</p>
				<select class="form-control" disabled="disabled">
					<option>{{ currentTimezone }}</option>
				</select>
			</div>
		</div>
		<!-- /calendarsContainer. -->

		<!-- Add days container. -->
		<div class="formContainer addDaysContainer apDetails">
			<!-- Date. -->
			<div class="aps-block" style="margin-top: 0">
				<p class="aps-title">
					{{ 'TOOLTIPS.AVAILABILITIES.SCHEDULES' | translate | uppercase }}
				</p>
			</div>

			<div *ngFor="let wd of slots.weekdaySlots">
				<div class="tdTimetables" [attr.data-key]="wd.key">
					<select
						class="selectMode selWeekday form-control"
						style="display: inline; line-height: 40px; margin-right: 5px"
						(change)="changeSelectedWeekday(wd.key)"
					>
						<option
							*ngFor="let day of calendarLabels.dayNames; let i = index"
							[selected]="i == wd.dayOfWeek"
							[value]="i"
						>
							{{ day }}
						</option>
					</select>
				</div>
				<div
					*ngFor="let item of wd.items"
					class="divTimeTableItem"
					[attr.data-key]="item.key"
				>
					<table>
						<tr>
							<!-- Hour from. -->
							<td>
								<select
									class="selectMode selHourSlotFrom form-control"
									style="line-height: 40px"
									(change)="fromHourSelected(wd.key, item.key)"
								>
									<option
										*ngFor="let hour of hoursList"
										[value]="hour"
										[selected]="hour == item.startString"
										[ngClass]="{
											halfHourSelectItem: hour.indexOf(':30') > -1,
											fullHourSelectItem: hour.indexOf(':30') == -1
										}"
									>
										{{ hour }}
									</option>
								</select>
							</td>

							<!-- To label. -->
							<td>
								<span class="spnTimetable">{{
									'GENERAL.TO' | translate | uppercase
								}}</span>
							</td>

							<!-- Hour to. -->
							<td>
								<select
									class="selectMode selHourSlotTo form-control"
									style="line-height: 40px"
									(change)="fromHourSelected(wd.key, item.key)"
								>
									<option
										*ngFor="let hour of hoursList"
										[value]="hour"
										[selected]="hour == item.endString"
										[ngClass]="{
											halfHourSelectItem: hour.indexOf(':30') > -1,
											fullHourSelectItem: hour.indexOf(':30') == -1
										}"
									>
										{{ hour }}
									</option>
								</select>
							</td>

							<!-- Remove and add item icons. -->
							<td>
								<span class="spnTimetable spnBtns">
									<img
										class="imgRemoveItem"
										src="/assets/images/icons/delete2.svg"
										(click)="removeHourInterval(wd.key, item.key)"
									/>
									<img
										class="imgAddItem"
										src="/assets/images/icons/add2.svg"
										(click)="addHourInterval(wd.key)"
									/>
								</span>
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>
		<!-- /addDaysContainer. -->

		<!-- Form buttons. -->
		<div class="formButtons addHour" *ngIf="availableDays.length > 0">
			<div class="btnCS btnSave" (click)="addDayBlock()">
				<img class="mnuIcon iconAdd" src="/assets/images/icons/add2.svg" />
				{{ 'OPERATIONS.ADDDAYHOUR' | translate }}
			</div>
		</div>
		<!-- /addHour. -->

		<!-- Form buttons. -->
		<div class="formButtons cancelAndSave">
			<div class="btnCS btnCancel" (click)="cancelAddNew()">
				<img class="mnuIcon" src="/assets/images/icons/cancel.svg" />
				{{ 'OPERATIONS.CANCEL' | translate }}
			</div>

			<div class="btnCS btnSave" (click)="save()">
				<img class="mnuIcon" src="/assets/images/icons/confirm.svg" />
				{{ 'OPERATIONS.SAVE' | translate }}
			</div>
		</div>
		<!-- /cancelAndSave. -->
	</section>
</section>
